const r = (t, e) => e || t;
export {
  r as getSuggestionDisplayValue
};
